import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'template', 'row', 'destroyField', 'levelLabel', 'levelInput'];

  connect() {
    this.renumberTiers();
  }

  addTier(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.containerTarget.insertAdjacentHTML('beforeend', content);
    this.renumberTiers();
  }

  removeTier(event) {
    event.preventDefault();

    const row = event.target.closest('[data-commission-tiers-target="row"]');
    const destroyField = row.querySelector('[data-commission-tiers-target="destroyField"]');

    if (destroyField) {
      destroyField.value = '1';
      row.style.display = 'none';
    } else {
      row.remove();
    }

    this.renumberTiers();
  }

  renumberTiers() {
    let level = 1;

    this.rowTargets.forEach((row) => {
      if (row.style.display === 'none') return;

      const label = row.querySelector('[data-commission-tiers-target="levelLabel"]');
      const input = row.querySelector('[data-commission-tiers-target="levelInput"]');

      if (label) label.textContent = level;
      if (input) input.value = level;

      level++;
    });
  }
}
